import type { FieldErrors } from "react-hook-form";

import type {
  ChoiceOptionErrorMessage,
  DateRangeErrorMessage,
  ScaleLabelErrorMessage,
  YesNoLabelErrorMessage,
} from "../components/form/question-authoring/shared";
import type { SurveyFormValues } from "../types/survey.types";

export interface SurveyQuestionErrorMessages {
  questionsError?: string;
  questionErrorMessages: (string | undefined)[];
  optionErrorMessages: (readonly ChoiceOptionErrorMessage[] | undefined)[];
  scaleLabelErrorMessages: ScaleLabelErrorMessage[];
  dateRangeErrorMessages: DateRangeErrorMessage[];
  yesNoLabelErrorMessages: YesNoLabelErrorMessage[];
}

export const getSurveyQuestionErrorMessages = (
  questions: SurveyFormValues["questions"],
  errors: FieldErrors<SurveyFormValues>,
): SurveyQuestionErrorMessages => ({
  questionsError: errors.questions?.message,
  questionErrorMessages: questions.map(
    (_, index) => errors.questions?.[index]?.data?.question?.message,
  ),
  optionErrorMessages: questions.map((_, index) => {
    const optionErrors = errors.questions?.[index]?.data?.options;

    return Array.isArray(optionErrors)
      ? optionErrors.map((option) => ({
          text: option?.text?.message,
          value: option?.value?.message,
        }))
      : undefined;
  }),
  scaleLabelErrorMessages: questions.map((_, index) => ({
    minLabel: errors.questions?.[index]?.data?.min_label?.message,
    maxLabel: errors.questions?.[index]?.data?.max_label?.message,
  })),
  dateRangeErrorMessages: questions.map((_, index) => ({
    minDate: errors.questions?.[index]?.data?.min_date?.message,
    maxDate: errors.questions?.[index]?.data?.max_date?.message,
    minDateTime: errors.questions?.[index]?.data?.min_datetime?.message,
    maxDateTime: errors.questions?.[index]?.data?.max_datetime?.message,
  })),
  yesNoLabelErrorMessages: questions.map((_, index) => ({
    yesLabel: errors.questions?.[index]?.data?.yes_label?.message,
    noLabel: errors.questions?.[index]?.data?.no_label?.message,
  })),
});
